import { FC } from 'react';
import { EntityLink } from '../../entity-link';
import useDrawer from '@/hooks/use-drawer.hook';
import ConversationHeader from '.';

interface Props {
  resourceId: string;
  openConversationId: string;
  focusedRequestId?: string;
  anchorActivityId?: string;
}

const PartialConversationHeader: FC<Props> = ({
  resourceId,
  openConversationId,
  focusedRequestId,
  anchorActivityId,
}) => {
  const { openDrawer } = useDrawer();

  const handleViewEntireConversation = () => {
    openDrawer('conversation', {
      conversationId: openConversationId,
      ...(focusedRequestId && { requestId: focusedRequestId }),
      ...(anchorActivityId && { anchorActivityId }),
    });
  };

  const leftElement = (
    <EntityLink
      title="View Entire Conversation"
      variant="text"
      onClick={handleViewEntireConversation}
    />
  );

  return <ConversationHeader resourceId={resourceId} leftElement={leftElement} />;
};

export default PartialConversationHeader;
